import React, { useEffect, useState } from "react";
import "./trainings.css";
import Navbar from "./Navbar";
import Footer from "./Footer";
import API_Root from "../Constants/API_Root";
import { auth } from "../Authentication/firebase/firebase";
import { useHistory } from "react-router-dom";
import { authFetch } from "../Authentication/authService";

const NewTraining = () => {
  const [isLogged, setIslogged] = useState(false);
  const [userEmail, setUserEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const history = useHistory();

  useEffect(() => {
    const isLoggedIn = localStorage.getItem("isLoggedIn") === "true";
    setIslogged(isLoggedIn);
    auth.onAuthStateChanged((user) => {
      if (user) {
        setIslogged(true);
        setUserEmail(user.email);
      } else {
        setIslogged(false);
        setUserEmail("");
      }
    });
  }, []);

  const handleBuyCourseAI = async () => {
    try {
      if (!isLogged || !userEmail) {
        history.push("/login");
      }

      setLoading(true);

      const payload = {
        email: userEmail,
        course_id: [1],
      };

      const response = await authFetch(
        `${API_Root}subscription/checkout-session-course`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        }
      );

      const data = await response.json();

      console.log("Stripe Response:", data);

      /*
        EXPECTING:
        {
          url: "...",
          session_id: "cs_live_XXXX"
        }
      */

      // SAVE SESSION ID
      if (data?.session_id) {
        localStorage.setItem("stripe_session_id", data.session_id);
      }

      // REDIRECT
      if (data?.url) {
        window.location.href = data.url;
      } else {
        alert("Unable to start checkout session.");
      }
    } catch (error) {
      console.error("Checkout Error:", error);
      alert("Something went wrong while starting checkout.");
    } finally {
      setLoading(false);
    }
  };

  const handleBuyCourse = async () => {
    try {
      if (!isLogged || !userEmail) {
        history.push("/login");
      }

      setLoading(true);

      const payload = {
        email: userEmail,
        course_id: [2],
      };

      const response = await authFetch(
        `${API_Root}subscription/checkout-session-course`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        }
      );

      const data = await response.json();

      console.log("Stripe Response:", data);

      // SAVE SESSION ID
      if (data?.session_id) {
        localStorage.setItem("stripe_session_id", data.session_id);
      }

      // REDIRECT
      if (data?.url) {
        window.location.href = data.url;
      } else {
        alert("Unable to start checkout session.");
      }
    } catch (error) {
      console.error("Checkout Error:", error);
      alert("Something went wrong while starting checkout.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Navbar />
      <div className="trainings-container">
        {/* PAGE TITLE */}
        <h1 className="page-title">Trainings</h1>

        {/* HEADER */}
        <div className="header-section">
          <h2>The E&S Solutions Training Centre</h2>

          <p>
            Generic AI workshops often fail to translate into the high-stakes
            world of Environmental and Social practice. Our founder, Ildiko
            Almasi Simsic, distilled her own steep AI learning curve into a
            curriculum purpose-built for our sector.
          </p>

          <p>
            Every module features an interactive workbook designed to make you
            think. We’ve replaced simple multiple-choice questions with hands-on
            scenarios—from resettlement mapping to climate risk modeling—that
            challenge your professional judgment.
          </p>

          <p>
            We are proud to offer the industry’s first training suite
            co-developed by E&S specialists and AI/Data Protection experts.
            These practical tools align with IFC Performance Standards and the
            Equator Principles.
          </p>
        </div>

        {/* COURSES */}
        <div className="courses-grid">
          {/* COURSE 1 */}
          <div className="course-card">
            <h3>01 | AI Literacy for E&S Professionals</h3>

            <p className="summary">
              Navigate the AI landscape with confidence. Move past the hype to
              identify where AI adds genuine value and where it introduces
              risks.
            </p>

            <p>
              <strong>Includes:</strong> Interactive Workbook with real-world
              case studies.
            </p>
            <p>
              <strong>Outcome:</strong> A Professional AI Action Plan tailored
              to your project portfolio.
            </p>

            <div className="training-video">
              <iframe
                width="100%"
                height="220"
                src="https://www.youtube.com/embed/dQPIAN9q9YQ"
                title="AI Literacy for E&S Professionals"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>

            <div className="cta-buttons">
              <button
                className="btn"
                onClick={handleBuyCourseAI}
                disabled={loading}
              >
                {loading ? "Redirecting..." : "Buy Course"}
              </button>
              {/* <button className="btn secondary">Bundle & Save</button> */}
            </div>
          </div>

          {/* COURSE 2 */}
          <div className="course-card">
            <h3>02 | Data Protection in E&S Impact Assessments</h3>

            <p className="summary">
              The essential safeguard for community trust. Learn field-tested
              principles for managing sensitive identifiers.
            </p>

            <p>
              <strong>Includes:</strong> Detailed Workbook with risk assessment
              frameworks.
            </p>
            <p>
              <strong>Outcome:</strong> Robust Data Governance Plans ensuring
              compliance.
            </p>

            <div className="training-video">
              <iframe
                width="100%"
                height="220"
                src="https://www.youtube.com/embed/ZiucyQ5lp4k?si=AF-gzcYQ47Eb7Zz0"
                title="AI Literacy for E&S Professionals"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>

            <div className="cta-buttons">
              <button
                className="btn"
                onClick={handleBuyCourse}
                disabled={loading}
              >
                {loading ? "Redirecting..." : "Buy Course"}
              </button>
              {/* <button className="btn secondary">Bundle & Save</button> */}
            </div>
          </div>

          {/* COURSE 3 */}
          <div className="course-card coming-soon">
            <h3>03 | Prompt Engineering for E&S Practitioners</h3>

            <p className="summary">
              Master precision output. Learn to engineer context-rich prompts
              for structured, professional deliverables.
            </p>

            <p>
              <strong>Includes:</strong> Hands-on Workbook for building prompt
              logic.
            </p>
            <p>
              <strong>Outcome:</strong> A reusable Prompt Library to save hours.
            </p>

            <div className="cta-buttons">
              <button className="btn disabled">Coming Soon</button>
              <button className="btn secondary">Notify Me</button>
            </div>
          </div>
        </div>

        {/* DELIVERY OPTIONS */}
        <div className="delivery-section">
          <h2>Flexible Delivery to Suit Your Team</h2>

          <div className="delivery-grid">
            <div>
              <h4>Self-Paced Online</h4>
              <p>Learn on your own schedule with bite-sized lessons.</p>
            </div>

            <div>
              <h4>Live Virtual Masterclass</h4>
              <p>Interactive team learning via Zoom/Teams.</p>
            </div>

            <div>
              <h4>In-Person Intensive</h4>
              <p>High-impact, on-site training for workflow transformation.</p>
            </div>
          </div>

          <div className="offer-box">
            <strong>Limited Time Offer:</strong> Use code [IAIA26] at
            checkout and get 20% off
          </div>

          <p className="footer-text">
            Transform your professional judgment into a force multiplier.
          </p>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default NewTraining;
